export const METADATA_BASE = '/metadata';
export const FINANCE_BASE = '/finance';
export const PROFESSIONAL_BASE = '/professional';

export const INVITED_TEAM_ID_QUERY_PARAM = 'invitedTeamId' as const;
